import { api, ApiTags } from '../../api';

import { ChallengeRequest, ChallengeResponse } from './types';

const challengeApi = api.injectEndpoints({
    endpoints: build => ({
        getChallenge: build.query<ChallengeResponse, ChallengeRequest>({
            query: ({ challengeId }) => `/challenges/${challengeId}`,
            providesTags: (result, _, request) =>
                result ? [{ type: ApiTags.Challenges, id: request.challengeId }] : [],
        }),
        getChallenges: build.query<ChallengeResponse[], void>({
            query: () => '/challenges',
            providesTags: [{ type: ApiTags.Challenges, id: 'LIST' }],
        }),
    }),
});

export const { useGetChallengeQuery, useGetChallengesQuery } = challengeApi;
